import { useLiveQuery } from "dexie-react-hooks"

import type { LiveQueryResult } from "../../types"
import { type ConfigLocal, getConfig } from "./config"

export function useSessionConfig(sessionId: string): LiveQueryResult<ConfigLocal> {
  return useLiveQuery(async () => ({ data: await getConfig(sessionId), isLoading: false }), [sessionId], {
    data: undefined,
    isLoading: true,
  })
}
